class Preregistration {
	id = null;
	candidate_id = null;
	first_name = '';
	last_name = '';
	email = '';
	phone = '';
	oib = null;
	partner_id = null;
	course_id = null;
	planned_course_id = null;
	login_type_id = null;
	start_date = null;
	office_id = null;
	author_id = null;
	note = '';
	seen = false;
	notified = false;
	correctional = false;
	active = true;
	has_plan = true;
	manual_enrollment = false;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Preregistration;
